module.exports = __webpack_public_path__ + "img/plus-aktiv.f4ddf534.svg";